// Matches the backend SendAndSaveOption enum:
// SaveNone = 0, SaveOne = 1 (original draft only), SaveAll = 2 (one per recipient)
export enum MailMergeSendCopyMode {
    SaveNone = 'saveNone',
    SaveOne = 'saveOne',
    SaveAll = 'saveAll',
}

export interface MailMergeViewState {
    /** Name of the mail merge data sheet */
    sheetName: string;
    /** Tabular recipient data rows (header keys → cell values) */
    data: Record<string, string>[];
    /** How draft copies are saved when sending — set at send time by the send dialog */
    sendCopyMode?: MailMergeSendCopyMode;
}
